<script>
import axios from 'axios'
import { VueEditor, Quill } from 'vue2-editor'
import { mapGetters, mapState } from 'vuex'
export default
{
    name: 'mv-news-form',

    components: { VueEditor },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    computed:
    {
        ...mapGetters({locale: 'generalCurrentLocale',}),

        ...mapState({post_tags: (state) => state.general.post_tags}),

        postTag:
        {
            get()
            {
                return this.post_tags.findByModelId(this.model.post_tag_id)
            },

            set(val)
            {
                if (val && val.id)
                    this.model.post_tag_id = val.id
                else
                    this.model.post_tag_id = null
            },
        },
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        addFileFirst(file)
        {
            this.model.attachments.unshift(file)
        },

        addCover(file)
        {
            if (file && file.id)
                this.model.cover_id = file.id
            else
                this.model.cover_id = null
            this.model.cover = file
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        addVideo(file)
        {
            this.model.videos.push(file)
        },

    },

    data()
    {
        return {
            cities: [],
            editorSettings: {
                imageResize: {},
            },
        }
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.TITLE') }}
            </label>
            <div class="col-md-4">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.title">
                </div>
            </div>
            <div class="col-md-4">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.title_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.POST_TAG') }}
            </label>
            <div class="col-md-8">
                <v-select :options="post_tags" v-model="postTag" label="name_hu">
                </v-select>
            </div>
        </div>

        <div class="form-group row" v-if="model.id">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.CREATED_AT') }}
            </label>
            <div class="col-md-8">
                <mv-date-time-picker v-model="model.created_at"></mv-date-time-picker>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.SLUG') }}
            </label>
            <div class="col-md-8">
                <input type="text" class="form-control" v-model="model.slug">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.EXCERPT') }}
            </label>
            <div class="col-md-8">
                <textarea v-model="model.excerpt" class="form-control" rows="4" v-if="locale == 'hu'">

                </textarea>

                <textarea v-model="model.excerpt_en" class="form-control" rows="4" v-else>

                </textarea>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('MENU.MEDIA') }}
            </label>
            <div class="col-md-8">
                <input type="checkbox" v-model="model.is_media">
            </div>
        </div>

        <div class="form-group row" v-if="model.is_media">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <label class="btn btn-sm btn-primary">
                    <mv-uploader ref="uploader2" multiple @upload-done="addFile($event)" accept="image/*" type="media"></mv-uploader>
                    <icon name="file"></icon>
                </label>
            </div>
        </div>

        <div class="form-group row" v-if="model.is_media">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row" v-if="model.is_media">
            <div class="col-md-4">
                <label>
                    {{ $t('GENERAL.VIDEO') }}
                </label>
            </div>
            <div class="col-md-6">
                <mv-video @upload-done="addVideo($event)">
                </mv-video>
            </div>
        </div>

        <div class="form-group row" v-if="model.is_media">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <div v-for="video in model.videos" :key="video.id" class="row">
                    <div class="col-sm-10">
                        <iframe  width="320" height="160" :src="'https://www.youtube.com/embed/' + video.video" allowFullScreen="true">

                        </iframe>
                    </div>
                    <div class="col-sm-2 vertical-align-video" @click.prevent.stop="removeVideo(video)">
                        <button class="btn btn-danger btn-xs">&times;</button>
                    </div>
                </div>
            </div>

        </div>

        <div class="form-group row" v-if="!model.is_media">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-8">
                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*" :quality="4"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row" v-if="!model.is_media">
            <div class="col-md-4">

            </div>
            <div class="col-md-8">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.COVER_IMAGE') }}
            </label>
            <div class="col-md-8">
                <label class="btn btn-sm btn-primary">
                    <mv-uploader ref="uploader" multiple @upload-done="addCover($event)" accept="image/*" type="cover"></mv-uploader>
                    <icon name="picture-o"></icon>
                </label>
            </div>
        </div>

        <div class="form-group row" v-if="model.cover">
            <div class="col-md-4">

            </div>
            <div class="col-md-8">
                <mv-attachment :attachment="model.cover">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('POST.PINNED') }}
            </label>
            <div class="col-md-8">
                <input type="checkbox" v-model="model.pinned">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('POST.CONTENT')}}
            </label>
            <div class="col-md-8">
                <vue-editor
                    v-if="locale == 'hu'"
                    :editorOptions="editorSettings"
                    v-model="model.content">
                    </vue-editor>
                <vue-editor
                    v-else
                    :editorOptions="editorSettings"
                    v-model="model.content_en">
                    </vue-editor>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('POST.SCHEDULE_AT')}}
            </label>
            <div class="col-md-8">
                <mv-date-time-picker v-model="model.publish_at"></mv-date-time-picker>
            </div>
        </div>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/NewsForm.vue